import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    beta: 'Alpha',
    description:
      'Ankr Automate is presently in Alpha phase. Feedback is welcome as we refine our product.',
    feedback: 'Leave feedback',
  },
};
